import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ApplicationFrameService {
  public headerElement: HTMLElement;

  constructor() {}
}
